import axios from "axios";

const editTourById = async (token, tourId, fields) => {
  const updateValues = {
    artist: fields.artist,
    name: fields.name
  }
  const path = `${process.env.REACT_APP_BACKEND_API_URL}/tours/${tourId}`;

  try {
    const response = await axios.put(path, updateValues, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    return response;
  } catch (error) {
    console.log(error.response);
    return error.response;
  } 
};

export default editTourById;